module.exports = __webpack_public_path__ + "img/icon-e.485f8075.png";